import Text from 'components/ui/Text';

type SkuCellProps = {
    sku?: string | null;
};

const SkuCell = ({ sku }: SkuCellProps) => {
    return (
        <Text fontSize={12} color="textFaded">
            {sku || '-'}
        </Text>
    );
};

export default SkuCell;
